/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { IPropertyConverter, JsonValue, TaJson } from "ta-json";

import { InvalidOperationError } from "../errors/invalid-operation-error";
import Link from "../link";
import { RelationResource } from "../models/relation-resource";

export class RelationResourceConverter implements IPropertyConverter {
    /**
     * Serializes a RelationResource or a Link into a JsonValue.
     *
     * @param value - A RelationResource or a Link
     *
     * @returns A Json Value.
     */
    serialize(value: RelationResource | Link): JsonValue {
        return TaJson.serialize(value) as JsonValue;
    }

    /**
     * Deserializes a JsonValue into a RelationResource or a Link.
     *
     * @param value - A Json Value
     *
     * @returns A RelationResource or a Link.
     */
    deserialize(value: JsonValue): RelationResource | Link {
        if (!value) {
            throw new InvalidOperationError("Can't deserialize falsy value.");
        } else if (typeof value !== "object" || value instanceof Array) {
            throw new InvalidOperationError(
                `Expected a value of type 'JSON', but value was of type '${typeof value}'.`
            );
        }

        const obj: any = typeof value === "string" ? JSON.parse(value) : JSON.parse(JSON.stringify(value));

        if (obj.href) {
            return TaJson.deserialize<Link>(obj, Link);
        } else if (this.isRelationResource(obj)) {
            return TaJson.deserialize<RelationResource>(value, RelationResource);
        } else {
            throw new InvalidOperationError("Not a known format");
        }
    }

    private isRelationResource(arg: any): arg is RelationResource {
        return arg.self !== undefined;
    }
}
